export default __webpack_public_path__ + "static/media/bg-image-7.905218e2.jpg";